import {createApp} from 'vue'
import RequestRole from './RequestRole'

const el = '.kb-component--request-role'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((RequestRoleDOM)=>{
        
            const component = createApp(RequestRole).use(Store)
            component.mount(RequestRoleDOM)
        })
    }
}